<template>
  <sidebar-layout
    :show-leaderboard-ad="loading === 0"
  >
    <div class="auth-page auth-page--register">
      <site-logo show-secondary-shn-logo />
      <site-masthead />
      <h1>Create Your Account</h1>
      <p class="auth-page__message" data-test-id="auth-page-message">
        Create your account to join the conversation, connect with others and
        receive emails from {{ this.$site.name }}
      </p>
      <register-with-email />
      <or-divider />
      <social-login
        :google-button-text="googleTextButton"
        :facebook-button-text="facebookTextButton"
      />
      <p class="auth-page__navigation">
        Already have an account?
        <button-component
          class="text-button text-button--link-style"
          data-test-id="register-page-log-in-button"
          @click="$store.dispatch('openLoginDialog')"
        >
          Log in
        </button-component>
      </p>
      <disclaimer-component-with-recaptcha />
    </div>
    <template v-slot:sidebar-ads>
      <sidebar-ads v-if="loading === 0" :sections="sidebarAdSections" />
    </template>
  </sidebar-layout>
</template>

<script>
import SiteLogo from '@/components/Global/SiteLogo.vue';
import SiteMasthead from '@/components/Footer/SiteMasthead.vue';
import OrDivider from '@/components/Auth/OrDivider.vue';
import SocialLogin from '@/components/Social/SocialLogin.vue';
import DisclaimerComponentWithRecaptcha from '@/components/Auth/DisclaimerComponentWithRecaptcha.vue';
import SidebarAds from '@/components/Ads/SidebarAds.vue';
import RegisterWithEmail from '@/components/Auth/RegisterWithEmail.vue';
import { config } from '@/configuration/nexus-config';
import { mapGetters } from 'vuex';
import ButtonComponent from '@/components/Global/ButtonComponent.vue';

export default {
  name: 'RegisterPage',
  components: {
    SiteLogo,
    SiteMasthead,
    OrDivider,
    SocialLogin,
    DisclaimerComponentWithRecaptcha,
    SidebarAds,
    RegisterWithEmail,
    ButtonComponent,
  },
  data() {
    return {
      loading: 0,
      sidebarAdSections: config.sidebarAdSections,
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    needsUsername() {
      return !!this.currentUser.email && !this.currentUser.username;
    },
    googleTextButton() {
      return 'Sign up with Google';
    },
    facebookTextButton() {
      return 'Sign up with Facebook';
    },
  },
  created() {
    // When a user registers with social but has not set a username they appear
    // logged out, we need to redirect them to the RegisterUsername page
    if (this.needsUsername) {
      // TODO: NEXUS-6319
      this.$router.push({ name: 'RegisterUsername', query: this.$route.query });
    }
  },
  mounted() {
    this.$emit('loaded');
  },
  beforeDestroy() {
    this.$store.dispatch('clearLogInForm');
  },
  metaInfo: {
    title: 'Create an Account',
    meta: [
      {
        name: 'robots',
        vmid: 'robots',
        content: 'noindex',
      },
    ],
    link: [
      { vmid: 'canonical', content: null },
    ],
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_auth-page';
</style>
